import { useCart } from '../contexts/CartContext'

interface ProductCardProps {
  id: string
  name: string
  description?: string
  price: number
  sku?: string
  image_url?: string
  is_available: boolean
  storeId: string
  storeName: string
}

export function ProductCard({
  id,
  name,
  description,
  price,
  sku,
  image_url,
  is_available,
  storeId,
  storeName,
}: ProductCardProps) {
  const { addItem } = useCart()

  function handleAdd() {
    addItem(storeId, storeName, { productId: id, name, price, sku })
  }

  return (
    <div className={`product-card ${!is_available ? 'product-card--unavailable' : ''}`}>
      {image_url ? (
        <img src={image_url} alt={name} className="product-card-img" />
      ) : (
        <div className="product-card-img product-card-img--placeholder">🪛</div>
      )}
      <div className="product-card-body">
        <h4 className="product-card-name">{name}</h4>
        {sku && <p className="product-card-sku">SKU: {sku}</p>}
        {description && <p className="product-card-desc">{description}</p>}
        <div className="product-card-footer">
          <span className="product-card-price">Q {price.toFixed(2)}</span>
          <span className={`badge ${is_available ? 'badge-green' : 'badge-gray'}`}>
            {is_available ? 'Disponible' : 'Agotado'}
          </span>
        </div>
        <button
          type="button"
          className="btn btn-primary btn-full"
          onClick={handleAdd}
          disabled={!is_available}
        >
          Agregar al carrito
        </button>
      </div>
    </div>
  )
}
